import type { ResultList, Role, RoleService, UsersErrorDTO } from '@empathyco/playboard-core-domain'
import { ref } from 'vue'
import { CONTAINER } from '../../config/inversify.config'
import { TYPES } from '../../config/inversify.types'
import { ColorEnum, IamRoleEnum } from '../../enums'

const loading = {
  list: ref(false),
}

const data = {
  list: ref<ResultList<Role> | undefined>(undefined),
}

const error = {
  list: ref<UsersErrorDTO | undefined>(undefined),
}

export function useRoles(): {
  loading: typeof loading
  data: typeof data
  error: typeof error
  list: () => Promise<void>
  getColor: (roleName: Role['name']) => ColorEnum
} {
  const service = CONTAINER.get<RoleService>(TYPES.RoleService)

  async function list(): Promise<void> {
    loading.list.value = true
    try {
      data.list.value = await service.list()
      error.list.value = undefined
    } catch (e) {
      data.list.value = undefined
      error.list.value = e as UsersErrorDTO
    } finally {
      loading.list.value = false
    }
  }

  function getColor(roleName: Role['name']): ColorEnum {
    return (
      {
        [IamRoleEnum.INTERNAL_ADMIN]: ColorEnum.ORANGE_75,
        [IamRoleEnum.PARTNER_REQUESTS]: ColorEnum.ORANGE_75,
        [IamRoleEnum.PARTNER_ADMIN]: ColorEnum.ORANGE_75,
        [IamRoleEnum.SEARCH_ADMIN]: ColorEnum.ORANGE_75,
        [IamRoleEnum.SEARCH_MANAGER]: ColorEnum.PURPLE_75,
        [IamRoleEnum.SEARCH_ANALYST]: ColorEnum.OCEAN_75,
        [IamRoleEnum.MERCHANT]: ColorEnum.PURPLE_75,
        [IamRoleEnum.EXPERIMENT_MAKER]: ColorEnum.PURPLE_75,
        [IamRoleEnum.EXPERIMENT_USER]: ColorEnum.OCEAN_75,
        [IamRoleEnum.USER_MANAGER]: ColorEnum.ORANGE_75,
      }[roleName] ?? ColorEnum.DEFAULT
    )
  }

  return {
    loading,
    data,
    error,
    list,
    getColor,
  }
}
